<template>
    <div id="manualModal" class="modal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content" style="width: 800px; left: -100px;">
            <div class="modal-header">
              <h5 class="modal-title">Manual</h5>
              <button @click="closeManualModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row justify-content-between mb-4">
                <div class="col-md-4 text-start">
                  <label class="form-label" for="">FDAY</label>
                  <input disabled v-model="getDate" class="form-control" type="date">
                </div>
                <div class="col-md-4 text-start">
                  <label class="form-label" for="">Carrier</label>
                  <input v-model="manualForm.CARRIER" class="form-control" type="text" maxlength="4">
                </div>
                <div class="col-md-4 text-start">
                  <label class="form-label" for="">FNO</label>
                  <input v-model="manualForm.FNO" class="form-control" type="text" maxlength="15">
                </div>
              </div>
              <div class="row justify-content-between mb-4">
                <div class="col-md-4 text-start">
                  <label class="form-label" for="">Suffix</label>
                  <input v-model="manualForm.SUFFIX" class="form-control" type="text" maxlength="2">
                </div>
                <div class="col-md-4 text-start">
                  <label class="form-label" for="">DEP</label>
                  <input v-model="manualForm.DEP" class="form-control" type="text" maxlength="4">
                </div>
                <div class="col-md-4 text-start">
                  <label class="form-label" for="">ARR</label>
                  <input v-model="manualForm.ARR" class="form-control" type="text" maxlength="4">
                </div>
              </div>
              <div class="row justify-content-between mb-4">
                <div class="col-md-6 text-start">
                  <label class="form-label" for="">STD</label>
                  <date-picker v-model="manualForm.STD" class="form-control custom-time" type="time" :minute-step="1" value-type="format" format="HH:mm"></date-picker>
                </div>
                <div class="col-md-6 text-start">
                  <label class="form-label" for="">STA</label>
                  <date-picker v-model="manualForm.STA" class="form-control custom-time" type="time" :minute-step="1" value-type="format" format="HH:mm"></date-picker>
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-md-12 text-start">
                  <label class="form-label" for="">Crew Manual</label>
                  <input v-model="manualForm.CREW" class="form-control" type="text" style="text-transform: uppercase;">
                </div>
              </div>
              <div class="text-start mt-5" style=""><input style="padding: .75rem; text-transform: uppercase" class="w-100" v-model="search" placeholder="Search"></div>
              <div class="employee-area" style="height: 300px; overflow: auto;">
                <table class="core-table table table-striped">
                  <thead>
                    <th>Name</th>
                    <th>Department</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item) in filteredData" :key="item.ID">
                      <td>{{item.ADISOYADI}}</td>
                      <td>{{ item.AltBirimIsim }}</td>
                      <td @click = "addTech(item.ADISOYADI)"><button class="core-add-btn rounded">Add</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button @click="deleteById()" type="button" class="core-close-btn rounded">Delete</button>
              <button @click="insertManual()" type="button" class="core-save-btn rounded">Save</button>
            </div>
          </div>
        </div>
      </div>
</template>
<script>

import 'vue2-datepicker/index.css';
import DatePicker from 'vue2-datepicker';
import { mapActions } from 'vuex';
import {GlobalFunctionAndStateMixin} from "../../src/utils/mixins.js";
    export default {
      props: ['messageFromParent', "id"],
      mixins: [GlobalFunctionAndStateMixin],
        name: 'ManualModal',
        components: {
           DatePicker
        },
        data() {
            return{
              techData: null,
              getManual: null,
              search: '',
              manualForm:{
                ID: -1,
                FDAY: '',
                CARRIER: '',
                FNO: '',
                SUFFIX: '',
                DEP: '',
                ARR: '',
                STD: '',
                STA: '',
                CREW: '',
                CREATEDT: '',
                MODIFYDT : '',
              },
            }
        },
        mounted() {
          this.TR2EN;
        },

        created() {
          this.getTechData();
          this.getData();
        },

        computed: {
          getDate(){
            let newDate = '';
            newDate = this.splitDate(this.messageFromParent).formatted_date;
            return newDate;
          },
          filteredData() {
            let filteredData = this.TR2EN;
            let text = '';
            if (this.search) {
              text = this.search.toUpperCase().replace('İ','I').replace('Ö', 'O').replace('Ü','U')
              .replace('Ş', 'S').replace('Ç', 'C').replace('Ğ','G')
            filteredData = filteredData.filter((row) => {
              return Object.values(row).some((value) => {
                return String(value).toUpperCase().includes(text.toUpperCase());
          });
        });
      }
      return filteredData;
    },

    TR2EN(){
            let newArr = [];
            newArr = JSON.parse(JSON.stringify(this.techData).replaceAll('İ','I').replaceAll('Ö', 'O').replaceAll('Ü','U')
            .replaceAll('Ş', 'S').replaceAll('Ç', 'C').replaceAll('Ğ','G'))
            return newArr;
          },
        },

        methods: {
          ...mapActions("DailyManual",["getAllDataFromApi", "getAllTechnicalDataFromApi", "insertManualData", "deleteByManualID","getManualByID"]),

          addTech(name){
            this.manualForm.CREW += name + ",";
          },

          childMethod() {
            let dataById = [];
            this.$store.dispatch("DailyManual/getManualByID", this.id)
              .then((response) => {
                dataById = JSON.parse(response.jsondata);
                this.manualForm.DEP     = dataById.DEP;
                this.manualForm.ARR     = dataById.ARR;
                this.manualForm.CARRIER = dataById.CARRIER;
                this.manualForm.CREW    = dataById.CREW;
                this.manualForm.FNO     = dataById.FNO;
                this.manualForm.SUFFIX  = dataById.SUFFIX;
                this.manualForm.STA     = dataById.STA.substring(11,16);
                this.manualForm.STD     = dataById.STD.substring(11,16);
                this.manualForm.FDAY    = this.splitDate(this.getDate).formatted_Api;
                this.manualForm.ID      = parseInt(this.id);   
              });
          },

          triggerParentMethod() {
            this.$emit('child-event');
          },

          getData(){
              this.$store.dispatch('DailyManual/getAllDataFromApi').then((response) => {
                this.getManual = JSON.parse(response.jsondata);
              });
            },

          getTechData(){
            if(!localStorage.getItem('employeeData')){
              this.$store.dispatch('DailyManual/getAllTechnicalDataFromApi').then((response) => {
                this.techData = JSON.parse(response.jsondata).ListItems;
                //console.log(this.techData);
              })
            }
            else this.techData = JSON.parse(localStorage.getItem('employeeData')).ListItems;
            //console.log(this.techData);
            },
            deleteById(){
              this.$store.dispatch('DailyManual/deleteByManualID', this.id).then((response) => {
                console.log(response);
              });
              this.triggerParentMethod();
              this.closeManualModal();
            },
            async insertManual(){
              this.manualForm.CREATEDT = this.splitDate(new Date).formatted_Api;
              this.manualForm.MODIFYDT = this.splitDate(new Date).formatted_Api;
              this.manualForm.FDAY     = this.splitDate(this.getDate).formatted_Api;
              this.manualForm.STD      = this.splitDate(this.manualForm.FDAY).formatted_date + 'T' + this.manualForm.STD + ':00';
              this.manualForm.STA      = this.splitDate(this.manualForm.FDAY).formatted_date + 'T' + this.manualForm.STA + ':00';
              //console.log(this.manualForm);

              await this.$store.dispatch('DailyManual/insertManualData', this.manualForm).then((response) => {
                console.log(response);
              });
              this.triggerParentMethod();
              this.closeManualModal();
            },
            closeManualModal(){
            this.selectedManualId = -1;
            this.manualForm.ID = -1;
            let modal = document.getElementById("manualModal");
            modal.style.display = 'none';
            this.search = '';
          },
        },
      }
    
</script>
<style scoped>
.modal{
  font-size: 1rem;
  font-family: "NunitoBold";
}
.employee-area th,tr td{
  text-align: start;
}
.employee-area{
  margin-top: 15px;
}
.custom-time{
  border: none !important;
  padding: 0 !important;
  height: 38px;
}
</style>